import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {
    GameSessionPromotionEvents,
    GameSessionPromotionModule,
    GameSessionPromotionStates
} from '@gongxigames/framework/promotions';

export class GameSessionPromotionInitState extends ModuleState<null, GameSessionPromotionModule, GameSessionPromotionEvents> {
    protected setupEvents(): void {
        this.setEventHandler('General.Game.STARTED', this.onGameStarted.bind(this));
    }

    private onGameStarted(): void {
        const promotion = this.module.getPromotion();

        if (promotion.hasPromotion()) {
            this.module.gotoState(!this.module.nextActionIsSpin ? GameSessionPromotionStates.RESTORE : GameSessionPromotionStates.START);
        } else {
            this.module.gotoState(GameSessionPromotionStates.DISABLED);
        }
    }
    public onEnterState(): void {}
    public onLeaveState(): void {}
}
